module.exports = __webpack_public_path__ + "static/img/cqjy.1eeecf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cqjy.png
// module id = Znwz
// module chunks = 0